import * as actionTypes from "./actionTypes";
import * as actions from './index';


export const updateFlexObjectsSuccess = (data) => {
    return {
        type: actionTypes.FLEX_UPDATE_FLEXOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateFlexObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateFlexObjectsSuccess(obj));
    }
}

export const getFlexTags = (search = "", options = { op: "listall", searchterm: "" }) => {
    let data = [];
    return (dispatch) => {
        window.flow.searchTags(search, options).then((res) => {
            if (res) {
                for (let i in res) {
                    if (res[i].id) {
                        let txt = res[i].word;
                        if (res[i].cat) txt += `(${res[i].cat})`;
                        data.push({ ...res[i], ID: res[i].id, DE: txt, EN: txt });
                    }
                }
            }
            dispatch(actions.updateFlexObjects({ flexTags: data }));
        }).catch(err => {
            console.log("LOGS: getFlexTags err", err);
        });
    };
};